 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import KINGOFSTORMS_COPYRIGHT from '@/components/KingofStorms_copyright'
 import KINGOFSTORMS_TOC from '@/components/KingofStorms_toc'
 import KINGOFSTORMS_FRON_1 from '@/components/KingofStorms_fron_1'
 import KINGOFSTORMS_AD_CARD_1 from '@/components/KingofStorms_ad_card_1'
 import KINGOFSTORMS_DEDI_1 from '@/components/KingofStorms_dedi_1'
 import KINGOFSTORMS_EPIG_1 from '@/components/KingofStorms_epig_1'
 import KINGOFSTORMS_PROL_1 from '@/components/KingofStorms_prol_1'
 import KINGOFSTORMS_CHAP_1 from '@/components/KingofStorms_chap_1'
 import KINGOFSTORMS_CHAP_2 from '@/components/KingofStorms_chap_2'
 import KINGOFSTORMS_CHAP_3 from '@/components/KingofStorms_chap_3'
 import KINGOFSTORMS_CHAP_4 from '@/components/KingofStorms_chap_4'
 import KINGOFSTORMS_CHAP_5 from '@/components/KingofStorms_chap_5'
 import KINGOFSTORMS_CHAP_6 from '@/components/KingofStorms_chap_6'
 import KINGOFSTORMS_CHAP_7 from '@/components/KingofStorms_chap_7'
 import KINGOFSTORMS_CHAP_8 from '@/components/KingofStorms_chap_8'
 import KINGOFSTORMS_CHAP_9 from '@/components/KingofStorms_chap_9'
 import KINGOFSTORMS_CHAP_10 from '@/components/KingofStorms_chap_10'
 import KINGOFSTORMS_CHAP_11 from '@/components/KingofStorms_chap_11'
 import KINGOFSTORMS_CHAP_12 from '@/components/KingofStorms_chap_12'
 import KINGOFSTORMS_CHAP_13 from '@/components/KingofStorms_chap_13'
 import KINGOFSTORMS_CHAP_14 from '@/components/KingofStorms_chap_14'
 import KINGOFSTORMS_CHAP_15 from '@/components/KingofStorms_chap_15'
 import KINGOFSTORMS_CHAP_16 from '@/components/KingofStorms_chap_16'
 import KINGOFSTORMS_CHAP_17 from '@/components/KingofStorms_chap_17'
 import KINGOFSTORMS_CHAP_18 from '@/components/KingofStorms_chap_18'
 import KINGOFSTORMS_CHAP_19 from '@/components/KingofStorms_chap_19'
 import KINGOFSTORMS_CHAP_20 from '@/components/KingofStorms_chap_20'
 import KINGOFSTORMS_CHAP_21 from '@/components/KingofStorms_chap_21'
 import KINGOFSTORMS_EPIL_1 from '@/components/KingofStorms_epil_1'
 import KINGOFSTORMS_AFTE_1 from '@/components/KingofStorms_afte_1'
 import LOVE_2 from '@/components/love_2'
 import KINGOFSTORMS_AUTH_BIO_1 from '@/components/KingofStorms_auth_bio_1'
 import KINGOFSTORMS_TEAS_1 from '@/components/KingofStorms_teas_1'
 import KINGOFSTORMS_APPE_1 from '@/components/KingofStorms_appe_1'
 import KINGOFSTORMS_APPE_2 from '@/components/KingofStorms_appe_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/KingofStorms_toc",
 			"name" : "KingofStorms_toc",
 			"component" : KINGOFSTORMS_TOC
 		},
 		{
 			"path" : "/KingofStorms_fron_1",
 			"name" : "KingofStorms_fron_1",
 			"component" : KINGOFSTORMS_FRON_1
 		},
 		{
 			"path" : "/KingofStorms_ad_card_1",
 			"name" : "KingofStorms_ad_card_1",
 			"component" : KINGOFSTORMS_AD_CARD_1
 		},
 		{
 			"path" : "/KingofStorms_dedi_1",
 			"name" : "KingofStorms_dedi_1",
 			"component" : KINGOFSTORMS_DEDI_1
 		},
 		{
 			"path" : "/KingofStorms_epig_1",
 			"name" : "KingofStorms_epig_1",
 			"component" : KINGOFSTORMS_EPIG_1
 		},
 		{
 			"path" : "/KingofStorms_prol_1",
 			"name" : "KingofStorms_prol_1",
 			"component" : KINGOFSTORMS_PROL_1
 		},
 		{
 			"path" : "/KingofStorms_chap_1",
 			"name" : "KingofStorms_chap_1",
 			"component" : KINGOFSTORMS_CHAP_1
 		},
 		{
 			"path" : "/KingofStorms_chap_2",
 			"name" : "KingofStorms_chap_2",
 			"component" : KINGOFSTORMS_CHAP_2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js